export const handleSendFunctionResponseToRFPAgent = async (functionResponse, updated, setChatSession, chatSessionRef, userInfo) => {
    const newChatSession = [...updated, functionResponse];
    setChatSession(newChatSession);
    chatSessionRef.current = newChatSession;
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/rfp/sendPromptToRFPAgent`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
        body: JSON.stringify({
            userId: userInfo._id,
            chatSession: newChatSession,
        }),
    });
    const data = await response.json();
    if (response.ok) {
        if (data.functionCall) {
            if(data.message){
                setChatSession(prev => {const updated = [...prev, { role: "model", parts: [{ text: data.message }, {functionCall:data.functionCall}] }]; 
                    chatSessionRef.current = updated; 
                    return updated});
            }
            else{setChatSession(prev =>{ const updated =  [...prev, { role: "model", parts: [ {functionCall:data.functionCall}] }]; 
                chatSessionRef.current = updated; 
                return updated});
            }
        }
        else{
            setChatSession(prev => {const updated = [...prev, { role: "model", parts: [{ text: data.message }] }]; chatSessionRef.current = updated; return updated});
        }
    }
    else {
        console.error("Error sending prompt to RFP Agent:", data.message);
    }
}